import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import MyApiClient from '../../../../api-client/MyApiClient';
import { Link, useNavigate } from 'react-router-dom';

import { conMotivo } from "../../Util/erroreServer";
export const FormPagamenti = (props) => {

	const formRef = useRef(null);
	const navigate = useNavigate();

	const [stripeEnabled, setStripeEnabled] = useState(false);
	const [bonificoEnabled, setBonificoEnabled] = useState(false);
	const [stripeKey, setStripeKey] = useState('');
	const [iban, setIban] = useState('');
	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
	const [verifying, setVerifying] = useState(false);
	const [verification, setVerification] = useState(null);

	const handleSaveClick = (e) => {
		e.preventDefault();

		const form = formRef.current;
		if (form) {

			let isValid = true;
			for (const element of form.elements) {
				if (element.name === "iban") {
					if (bonificoEnabled) {
						if (!element.value || element.value.length !== 27) {
							element.setCustomValidity("L'IBAN deve contenere esattamente 27 caratteri.");
							isValid = false;
						} else {
							element.setCustomValidity("");
						}
					} else {
						element.setCustomValidity("");
					}
				}
			}

			const validationErrors = [];

			if (stripeEnabled && !stripeKey) validationErrors.push('Chiave Stripe');
			if (bonificoEnabled && !iban) validationErrors.push('IBAN');

			if (validationErrors.length > 0) {
				setModalTitle("Errore di validazione");
				setModalText(`I seguenti campi obbligatori non sono stati compilati: ${validationErrors.join(', ')}.`);
				setModalShowed(true);
				return;
			}

			if (form.checkValidity() && isValid) {
				const saveData = async () => {
					try {
						const tokenDetailsString = sessionStorage.getItem('userDetails');
						if (tokenDetailsString) {
							const tokenDetails = JSON.parse(tokenDetailsString);
							const token = tokenDetails.idToken;
							const apiClient = new MyApiClient();
		
							let data_update = {
								club: {
									id: props.profile.club.id,
									paymentData: {
										stripe_enabled: stripeEnabled,
										bank_transfer_enabled: bonificoEnabled,
										stripe_api_key: stripeKey || undefined,
										bank_transfer_iban: iban || undefined,
									}
								} 
							};
		
							setLoadingShowed(true);
							const saveResult = await apiClient.updateProfile(token, data_update);
							setLoadingShowed(false);
		
							if (saveResult && saveResult.error) {
								setModalTitle("Errore durante l'operazione");
								setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
								setModalShowed(true);
							} else {
								navigate(0);
							}
						}
						setModalTitle("Errore durante l'operazione");
						setModalText(conMotivo("Si è verificato un errore durante il salvataggio."));
						setModalShowed(true);
					} catch (error) {
						console.error("Error fetching data:", error);
					}
				};
		
				saveData();
			} else {
				form.reportValidity();
			}
		}
	};

	const verificationVariant = () => {
		if (!verification) return 'secondary';
		if (!verification.valid) return 'danger';
		if (verification.chargesEnabled === false || verification.livemode === false) return 'warning';
		return 'success';
	};

	const handleVerifyClick = async () => {
		setVerification(null);

		const keyToVerify = (stripeKey ?? '').trim();
		if (!keyToVerify) {
			setVerification({ valid: false, message: 'Inserisci la chiave privata di Stripe prima di verificarla.' });
			return;
		}

		try {
			const tokenDetailsString = sessionStorage.getItem('userDetails');
			if (!tokenDetailsString) return;

			const token = JSON.parse(tokenDetailsString).idToken;
			const apiClient = new MyApiClient();

			setVerifying(true);
			const result = await apiClient.verifyClubStripeKey(token, keyToVerify);
			setVerifying(false);

			if (!result || result.error) {
				setVerification({ valid: false, message: result?.error ?? 'Verifica non riuscita.' });
				return;
			}

			setVerification(result);
		} catch (error) {
			console.error("Error verifying stripe key:", error);
			setVerifying(false);
			setVerification({ valid: false, message: 'Verifica non riuscita.' });
		}
	};

	// La chiave è cambiata: l'esito precedente non vale più.
	const handleStripeKeyChange = value => {
		setStripeKey(value);
		setVerification(null);
	};

	useEffect(() => {
		const paymentData = props.profile?.club?.paymentData;

		setStripeEnabled(!!paymentData?.stripe_enabled);
		setStripeKey(paymentData?.stripe_api_key ?? '');
		setBonificoEnabled(!!paymentData?.bank_transfer_enabled);
		setIban(paymentData?.bank_transfer_iban ?? '');
		setVerification(null);
	}, [props.profile]);
	
	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<Row className="align-items-start mt-4">
				<div className="col-xl-9">

					<Form ref={formRef} noValidate>
						<Card>
							<Card.Header>
								<h4 className="card-title">Integrazione con Stripe</h4>
							</Card.Header>
							<Card.Body>
								<Form.Check 
									type="switch"
									id="stripe-switch"
									label="Abilita Stripe"
									checked={stripeEnabled}
									onChange={e => setStripeEnabled(e.target.checked)}
								/>
								<Form.Group className="mt-3">
									<Form.Label>Chiave privata di Stripe (verrà criptata sui nostri sistemi)</Form.Label>
									<Form.Control
										required={stripeEnabled}
										disabled={!stripeEnabled}
										style={stripeEnabled ? {color: 'black'} : {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2'}}
										type="password"
										autoComplete="new-password"
										placeholder="Inserisci la chiave privata di Stripe"
										value={stripeKey ?? ''}
										name="stripeKey"
										onChange={e => handleStripeKeyChange(e.target.value)}
									/>
								</Form.Group>
								{stripeEnabled && (
									<div className="mt-3">
										<Button type="button" variant="outline-primary" onClick={handleVerifyClick} disabled={verifying}>
											{verifying
												? <><Spinner as="span" animation="border" size="sm" className="me-2" />Verifica in corso...</>
												: 'Verifica collegamento'}
										</Button>
									</div>
								)}
								{verification && (
									<Alert variant={verificationVariant()} className="solid mt-3" style={{color: 'black'}}>
										<strong>{verification.valid ? 'Chiave valida.' : 'Chiave non valida.'}</strong>{' '}
										{verification.message}
										{verification.accountName && (
											<div className="mt-2">Account Stripe: <strong>{verification.accountName}</strong></div>
										)}
										{verification.livemode === false && (
											<div className="mt-2">Attenzione: è una chiave di <strong>test</strong>, non incasserà pagamenti reali.</div>
										)}
									</Alert>
								)}
							</Card.Body>
						</Card>
						<Card>
							<Card.Header>
								<h4 className="card-title">Mostra IBAN in App per pagamenti bonifico</h4>
							</Card.Header>
							<Card.Body>
								<Form.Check 
									type="switch"
									id="bonifico-switch"
									label="Abilita Bonifico"
									checked={bonificoEnabled}
									onChange={e => setBonificoEnabled(e.target.checked)}
								/>
								<Form.Group className="mt-3">
									<Form.Label>IBAN</Form.Label>
									<Form.Control
										required={bonificoEnabled}
										disabled={!bonificoEnabled}
										style={bonificoEnabled ? {color: 'black'} : {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2'}}
										type="text"
										placeholder="Inserisci l'IBAN"
										value={iban ?? ''}
										name="iban"
										onChange={e => setIban(e.target.value)}
									/>
								</Form.Group>
							</Card.Body>
						</Card>
					</Form>
					{!props.isDisabled && <div className="d-flex justify-content-end gap-4"><Link onClick={handleSaveClick} to="#" className="btn btn-primary ">Salva</Link></div>}
				</div>
				<div className="col-xl-3">
					<Card>
						<Card.Body className="text-left">
							Abilitando l’opzione "Abilita Stripe" nel backend, il sistema richiede di inserire la chiave privata del tuo account Stripe e mostrerà in App all'utente la possibilità di pagare i propri acquisti presso la tua struttura utilizzando la carta di credito, per i prodotti specifici per cui vorrai confermare l'abilitazione del pagamento tramite carta.
							<br></br><br></br>
							Abilitando l’opzione "Abilita Bonifico" nel backend, il sistema richiede di inserire l'IBAN del tuo conto bancario e mostrerà in App all'utente la possibilità di pagare i propri acquisti presso la tua struttura utilizzando il bonifico, per i prodotti specifici per cui vorrai confermare l'abilitazione del pagamento tramite bonifico.
						</Card.Body>
					</Card>
				</div>
			</Row>
		</>
	)
}
export default FormPagamenti;